import mutations from "@/store/settings/mutations";
import state from "@/store/settings/state";

export default {
  state,
  mutations,
};
